import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const fetchEnv = async (id) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getEnvForModule&companyid=${user.companyid}&moduleid=${id}`,
  );

  return response.data;
};

const useGetEnvForModuleQuery = (id) => {
  return useQuery({
    queryKey: ["env", id],
    queryFn: () => fetchEnv(id),
    // 🔒 HARD GATE: never call API with null/undefined
    enabled: id !== null && id !== undefined,
    retry: true,
    cacheTime: 90000,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    staleTime: Infinity,
  });
};

export default useGetEnvForModuleQuery;
